import getStringDateAndHourFromDate from '../../../localUtils/getStringDateAndHourFromDate'

export default function getThirtyDaysAgo() {
  const today = new Date()
  const thirtyDaysAgo = new Date()

  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)

  const stringToday = getStringDateAndHourFromDate(today)
  const stringThirtyDaysAgo = getStringDateAndHourFromDate(thirtyDaysAgo)

  const options = {
    name: 'THIRTY_DAYS_AGO',
    label: '30 Dias',
    startDate: stringThirtyDaysAgo.date,
    finalDate: stringToday.date,
    startHour: '00:00',
    finalHour: '23:59',
  }

  return options
}
